import React, { useState } from "react";
import Row from "./RowEklok";
import TableList from "../../components/Table";
import { useTranslation } from "react-i18next";
import { getConnectedStatusString, getFormattedDate } from "../../utils/utils";

const List = ({
  items = [],
  add,
  onConnectDevice = () => {},
  onAddAction = () => {},
  onUpdateRowsAndPages = () => {},
}) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const filterItems = (items) =>
    items.filter((item) => {
      const name = item.name
        ? item.name.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const hw_id = item.hw_id
        ? item.hw_id.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const serial_id = item.serial_id
        ? item.serial_id.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const software_version = item.software_version
        ? item.software_version
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        : undefined;
      const formatted_last_mqtt_update = getFormattedDate(
        item.last_mqtt_update,
      );
      const last_mqtt_update = formatted_last_mqtt_update
        ? formatted_last_mqtt_update
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        : undefined;
      const connected = getConnectedStatusString(item.connected).includes(
        searchValue.toLowerCase(),
      );
      return (
        name ||
        hw_id ||
        serial_id ||
        software_version ||
        last_mqtt_update ||
        connected
      );
    });

  const headCells = [
    {
      id: "name",
      label: t("heads_list_ekloks.name"),
      sortable: true,
    },
    {
      id: "hw_id",
      label: t("heads_list_ekloks.hw"),
      sortable: true,
    },
    {
      id: "serial_id",
      label: t("heads_list_ekloks.serial"),
      sortable: true,
    },
    {
      id: "software_version",
      label: t("heads_list_ekloks.SW"),
      sortable: true,
    },
    {
      id: "last_mqtt_update",
      label: t("heads_list_ekloks.last_update"),
      sortable: true,
    },
    {
      id: "connected",
      label: t("heads_list_ekloks.connected"),
      sortable: true,
    },
    {
      id: "error",
      label: t("heads_list_ekloks.alarms"),
      sortable: true,
    },
    {
      id: "connect",
      label: t("heads_list_ekloks.actions"),
      sortable: false,
    },
  ];

  return (
    <TableList
      headCells={headCells}
      order="asc"
      orderBy="hw_id"
      items={filterItems(items)}
      page={0}
      rowsPerPage={5}
      setSearchValue={setSearchValue}
      add={add}
      addAction={onAddAction}
      onUpdateRowsAndPages={onUpdateRowsAndPages}
    >
      {(item) => (
        <Row
          headCells={headCells}
          onRefreshAction={onUpdateRowsAndPages}
          onConnectDevice={onConnectDevice}
          key={item.id}
          item={item}
        />
      )}
    </TableList>
  );
};

export default List;
